<template>
  <div>
    <PrimeDialog
      v-model:visible="visible"
      header="User Input Required"
      :modal="true"
      :closable="false"
      class="min-w-[60vw] min-h-[30vh]"
    >
      <FormFromMetaActionParameters
        :action-params="actionParams"
        :action="action"
        v-model:data="data"
        ref="dataForm"
      />
      <template #footer>
        <div class="flex gap-2 pt-1">
          <PrimeButton label="Submit" @click="submit" />
          <PrimeButton label="Cancel" @click="cancel" />
        </div>
      </template>
    </PrimeDialog>
  </div>
</template>

<script setup lang="ts">
import type { IMetaAction, IMetaActionParameter } from "~/types/scad";
import * as yup from "yup";
import { FormFromMetaActionParameters } from "#components";

const visible = defineModel<boolean>("visible");
const data = defineModel<Indexable | null>("data");

const dataForm = ref<InstanceType<typeof FormFromMetaActionParameters>>();

const props = defineProps<{
  actionParams: IMetaActionParameter[];
  action: IMetaAction;
}>();

const emits = defineEmits<{
  submit: [values: Indexable];
  cancel: [];
}>();

// Yup validation schema to check that all params are filled

const toast = useToast();

async function submit() {
  try {
    // console.log(validation);
    await dataForm.value?.validate(true);
    emits("submit", data.value ?? {});
  } catch (err) {
    if (err instanceof yup.ValidationError) {
      err.inner.forEach((validationError) => {
        toast.add({
          severity: "error",
          summary: "Validation Error",
          detail: validationError.message,
          life: 5000,
        });
      });
    } else {
      toast.add({
        severity: "error",
        summary: "Error",
        detail: err instanceof Error ? err.message ?? "An unexpected error occurred." : "An unexpected error occurred.",
        life: 5000,
      });
    }
  }
}

function cancel() {
  emits("cancel");
}
</script>

<style scoped></style>
